<template>
  <header>
    <div class="logo"><img src="/images/logos/logo.png" alt="logo"></div>
    <h1 class="header-title">Lorem ipsum.</h1>
    <small class="header-small">Lorem</small>
    <div class="parallax-img-wrapper"><img class="header-pi parallax-img" src="/images/photos/gallery/4.jpg" alt=""></div>
  </header>
</template>

<script>
export default {
  name: 'Header'
}
</script>
